
export default {
    head() {
        return {
            title: '404',
        }
    },
    props: ['error'],
}
